import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { dateFormatter, DateFormatTypes, isSuccessResponse } from '../utils'

import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const { data } = isSuccessResponse({ data: response })
  return {
    data:
      data?.processInstances?.map((item) => ({
        ...item,
        actionDownload: 'Download',
      })) ?? [],
    pagination: {
      size: 10,
      totalElements: data?.totalItems ?? 0,
      number: data?.pageNumber,
      totalPages: Math.ceil(data?.totalItems / 10) || 0,
    },
  }
}

const getPosBatchMakerApi = (data: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getPosBatchMakerList),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: getReqBody(data),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

const getReqBody = (data: any) => {
  return {
    page: RootStore.pagination?.number,
    size: 10,
    ...data,
    startDate: dateFormatter(RootStore.selectedDateInfo?.fromDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
    endDate: dateFormatter(RootStore.selectedDateInfo?.toDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
  }
}

export { getPosBatchMakerApi }
